
import { Component, Inject, OnInit, Optional, Input, ViewEncapsulation } from '@angular/core';
// Ask this --> about material module on importing
import { MatDialogRef, MAT_DIALOG_DATA, MatInputModule } from '@angular/material';
import { DialogData, RadioEventData } from '../../model/data.model';
import productConfig from '../../life-config/productCodeConfig.json';
@Component({
    selector: 'app-premium-breakup',
    templateUrl: './premium-breakup.component.html',
    styleUrls: ['./premium-breakup.component.css'],
    encapsulation: ViewEncapsulation.None,
})
export class PremiumBreakupComponent implements OnInit {

    radioEventData: RadioEventData;
    premBreakupRes: any;
    classNameObtained: string;
    riderList: any;
    quotesInitialInfo: any;
    productConf = productConfig.product_type;


    constructor(private dialogRef: MatDialogRef<PremiumBreakupComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: DialogData) {

        // Getitng response from modal data

        
        this.quotesInitialInfo = data['proposalInfo'];
        this.premBreakupRes = data['editProposalModal'];
        this.classNameObtained = data['classNameObtained'];
        this.riderList = data['optedRider'];

        
    }

    ngOnInit() {
    }

}



